export default "__VITE_ASSET__Coftqqsn__"